import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownTimerProps = {
  tone?: 'dark' | 'light';
  label?: string;
};
export function CountdownTimer({
  tone = 'dark',
  label = 'This special price expires in:'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: 'Hours'
  }, {
    value: minutes,
    unit: 'Min'
  }, {
    value: seconds,
    unit: 'Sec'
  }];
  const isDark = tone === 'dark';
  return <div className="mx-auto w-full max-w-xl text-center" role="timer" aria-live="off" data-id="element-21" data-mp="1fc3neqs3vmde">
      <p className={`mb-3 text-sm font-bold uppercase tracking-wide ${isDark ? 'text-gold-300' : 'text-danger'}`} data-id="element-22" data-mp="1acr24agvuncx">{label}</p>
      <div className="flex items-start justify-center gap-2 sm:gap-3" data-id="element-23" data-mp="15e632edda9q2">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-24" data-mp="34r0e8ocgwhoq" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-25" data-mp="34pyyi6kib70o">
              <span className={`flex h-16 w-[4.5rem] items-center justify-center rounded-xl font-display text-4xl font-black tabular-nums sm:h-20 sm:w-24 sm:text-5xl ${isDark ? 'bg-white text-navy-900' : 'bg-navy-900 text-white'}`} data-id="element-26" data-mp="2zrfeibph45ay">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${isDark ? 'text-white/70' : 'text-navy-700'}`} data-id="element-27" data-mp="124lofeitbt5d">{u.unit}</span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 font-display text-3xl font-black sm:pt-5 ${isDark ? 'text-gold-300' : 'text-navy-900'}`} data-id="element-28" data-mp="1utiu8i5u7xh8">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}